"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    supplierCustomer: 'Kund' || 'supplierCustomer',
    setDeliveryRules: 'Sätt leveransregler' || 'setDeliveryRules',
    writeCustomer: 'Skapa kund' || 'writeCustomer',
    importCustomer: 'Importera kunder' || 'importCustomer',
    writeContact: 'Lägg till / ändra' || 'writeContact',
    deactivate: 'Inaktivera' || 'deactivate',
    activate: 'Aktivera' || 'activate',
    removeContact: 'Ta bort kontakt' || 'removeContact',
    approveSupplierCustomer: 'Godkänn kund' || 'approveSupplierCustomer',
    blockSupplierCustomer: 'Blocka kund från köp' || 'blockSupplierCustomer',
    unblockSupplierCustomer: 'Tillåt kund att köpa' || 'unblockSupplierCustomer',
    changeOrderFullfillmentCenter: 'Ändra lagerställe' || 'changeOrderFullfillmentCenter',
    approveAlcoholLicense: 'Godkänn alkoholtillstånd' || 'approveAlcoholLicense',
    revokeAlcoholLicense: 'Återkalla alkoholtillstånd' || 'revokeAlcoholLicense',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    orderFullfillmentCenter: 'Lagerställe' || 'orderFullfillmentCenter',
    customerNumber: 'Kundnummer' || 'customerNumber',
    currency: 'Valuta' || 'currency',
    name: 'Företagsnamn på faktura' || 'name',
    restaurantNumber: 'Restaurangnummer (8 tecken)' || 'restaurantNumber',
    organisationNumber: 'Organisationsnummer' || 'organisationNumber',
    VATNumber: 'Momsnummer' || 'VATNumber',
    deliveryCountry: 'Land' || 'deliveryCountry',
    deliveryCountries: {
        SE: 'Sverige' || 'SE',
        FI: 'Finland' || 'FI',
        NO: 'Norge' || 'NO',
        DK: 'Danmark' || 'DK',
        IS: 'Island' || 'IS',
    },
    chain: 'Kedja' || 'chain',
    customerType: 'Kundtyp' || 'customerType',
    customerTypes: {
        horeca: 'HoReCa' || 'horeca',
        dvh: 'Dagligvaruhandel' || 'dvh',
        wholesale: 'Grossist' || 'wholesale',
        office: 'Kontor' || 'office',
        systembolaget: 'Systembolaget' || 'systembolaget',
        supplier: 'Leverantör till Flaivy' || 'supplier',
        export: 'Export' || 'export',
        other: 'Övrigt' || 'other',
    },
    yourReference: 'Kundreferens' || 'yourReference',
    email: 'Kundens e-post (används för orderbekräftelse)' || 'email',
    invoiceDeliveryType: 'Fakturaleveranssätt' || 'invoiceDeliveryType',
    invoiceDeliveryTypes: {
        PRINT: 'Utskrift' || 'PRINT',
        EMAIL: 'E-post' || 'EMAIL',
        ELECTRONICINVOICE: 'E-faktura' || 'ELECTRONICINVOICE',
    },
    emailInvoice: 'E-post för faktura' || 'emailInvoice',
    phone: 'Telefon' || 'phone',
    active: 'Aktiverad' || 'active',
    GLN: 'GLN-nummer för köparen' || 'GLN',
    GLNBY: 'GLN-nummer för köparen' || 'GLNBY',
    GLNIV: 'GLN-nummer för fakturering' || 'GLNIV',
    GLNCN: 'GLN-nummer för leveranspartner' || 'GLNCN',
    GLNDP: 'GLN-nummer för leveransmottagare' || 'GLNDP',
    GLNSU: 'GLN-nummer för leverantörslager' || 'GLNSU',
    invoiceAddress: 'Faktureringsadress' || 'invoiceAddress',
    invoiceAddress2: 'Faktureringsadress 2' || 'invoiceAddress2',
    invoiceZipCode: 'Postnummer på faktura' || 'invoiceZipCode',
    invoiceCity: 'Stad på faktura' || 'invoiceCity',
    approvedCustomer: 'Godkänd kund' || 'approvedCustomer',
    blocked: 'Kund har köpstopp' || 'blocked',
    blockedReason: 'Anledning till köpstopp' || 'blockedReason',
    requiresGroupInvoice: 'Samlingsfaktura' || 'requiresGroupInvoice',
    contractualCustomer: 'Avtalkund' || 'contractualCustomer',
    isBlockedFromCampaigns: 'Kunden är blockad från att ta del av kampanjer' ||
        'isBlockedFromCampaigns',
    invoiceCountry: 'Fakturaadress land' || 'invoiceCountry',
    invoiceCountries: {
        SE: 'Sverige' || 'SE',
        FI: 'Finland' || 'FI',
        NO: 'Norge' || 'NO',
        DK: 'Danmark' || 'DK',
        IS: 'Island' || 'IS',
    },
    deliveryName: 'Företagsnamn för leverans' || 'deliveryName',
    deliveryAddress: 'Leveransadress' || 'deliveryAddress',
    deliveryAddress2: 'Leveransadress 2' || 'deliveryAddress2',
    deliveryZipCode: 'Postnummer för leverans' || 'deliveryZipCode',
    deliveryCity: 'Stad för leverans' || 'deliveryCity',
    deliveryPhone: 'Leveranstelefon' || 'deliveryPhone',
    deliveryGLN: 'GLN-nummer för leverans' || 'deliveryGLN',
    hasAlcoholPermit: 'Har bekräftat alkoholtillstånd' || 'hasAlcoholPermit',
    minOrderValue: 'Minsta ordervärde för kund' || 'minOrderValue',
    isPossibleToPlaceOrderBelowOrderMinimum: 'Det är möjligt för kund att lägga order under kollikrav eller minsta ordervärde mot en ev.avgift.' ||
        'isPossibleToPlaceOrderBelowOrderMinimum',
    minCollisOnOrder: 'Minsta antal kollin för kund på order' || 'minCollisOnOrder',
    kegCountsAsNCollis: 'Hur många kollin varje fat räknas som på en order för kund' ||
        'kegCountsAsNCollis',
    deliveryBreakpointText: 'Brytpunktsförklaring' || 'deliveryBreakpointText',
    deliveryRules: 'Leveransregler' || 'deliveryRules',
    labels: 'Etiketter' || 'labels',
    owningSupplierOrganizationId: 'Leverantörs organisation' || 'owningSupplierOrganizationId',
    termsOfPayment: 'Betalningsvillkor' || 'termsOfPayment',
    termsOfPayments: {
        0: '0 dagar' || '0',
        10: '10 dagar' || '10',
        15: '15 dagar' || '15',
        20: '20 dagar' || '20',
        30: '30 dagar' || '30',
        35: '35 dagar' || '35',
        60: '60 dagar' || '60',
        70: '70 dagar' || '70',
        A: 'Autogiro' || 'A',
        K: 'Kontant' || 'K',
        PF: 'Postförskott' || 'PF',
    },
    exciseNumber: 'Punktskattenummer (13 tecken)' || 'exciseNumber',
    taxWarehouseNumber: 'Skatteupplagsnummer (13 tecken)' || 'taxWarehouseNumber',
    customFields: 'Extrafält' || 'customFields',
    supplierCustomerContacts: {
        id: 'Identitet' || 'id',
        name: 'Kundreferens' || 'name',
        email: 'E-post' || 'email',
        phone: 'Telefon' || 'phone',
    },
};
